export default __webpack_public_path__ + "static/media/icon_passportmanager.b1473973.svg";